import { Input } from '@/components/Input';
import { selectAnnualKms, setAnnualKms } from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { getNumber } from '@/utils/valueFormat';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'AnnualKms';

export function AnnualKms({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectAnnualKms);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean): void {
        const MAXIMUM = 1000000;
        const intValue = getNumber(value, MAXIMUM);
        if (intValue === currentState) return;
        dispatch(setAnnualKms(intValue));
    }

    function getValue(): string | undefined {
        return currentState?.toLocaleString();
    }

    function getPlaceholder(): string {
        return showErrors && !currentState
            ? 'Please enter annual kilometers'
            : 'Enter';
    }

    // ***** Render *****
    return (
        <div data-testid={testId} className='w-full'>
            <Input
                title='How many kilometers do you drive annually?'
                placeholder={getPlaceholder()}
                showErrors={showErrors}
                onChange={handleChange}
                id={`${baseId}-input-annualKms`}
                value={getValue()}
                showNumpad={true}
                tooltipContent='How many kilometers do you drive each year?'
            />
        </div>
    );
}
